import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setOpenLoginDesktopModal } from "../Store/buttonSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { BASE_URL } from "../api";
import accessDeniedLogo from "../assets/svg/accessDenied.svg";
import joulezLightIcon from "../assets/svg/JoulezLightIcon.svg";
import printIcon from "../assets/svg/PrintIcon.svg";
import SpinnerLoader from "../Components/SpinnerLoader";
import { setCurrentPage } from "../Store/pageSlice";

const TripReceiptDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const userToken = useSelector(
    (store) => store?.userDetailsSlice?.userDetails?.token
  );

  const profileDetails = JSON.parse(
    sessionStorage?.getItem("CurrentUserDetails")
  );

  const [tripReceiptDetails, setTripReceiptDetails] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [tripError, setTripError] = useState("");

    useEffect(() => {
      dispatch(setCurrentPage("trip-summary"));
    }, [dispatch]);

  useEffect(() => {
    sessionStorage.setItem("rentalTransPath", location?.pathname);
    if (!profileDetails) {
      dispatch(setOpenLoginDesktopModal(true));
    }
    //eslint-disable-next-line
  }, [dispatch, profileDetails]);

  const getTransactionDetails = async (bookingID) => {
    try {
      setLoader(true);
      const res = await axios.post(
        `${BASE_URL}booking/tripReceipt`,
        { bookingId: bookingID },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      setTripReceiptDetails(res?.data?.data);
      //console.log(res?.data?.data);
      if (res?.data?.data === null) {
        setTripError(res?.data?.message);
      }
      setLoader(false);
    } catch (error) {
      //console.log(error?.response?.data?.message);
      toast.error(error?.response?.data?.message);
      setLoader(false);
    }
  };

  const path = location.pathname;
  const parts = path.split("/").filter(Boolean);
  const lastPart = parts[parts.length - 1];

  useEffect(() => {
    if (userToken) {
      if (path.split("/").filter(Boolean)?.length === 2) {
        getTransactionDetails(lastPart);
      } else {
        toast.error(
          "We couldn't find any booking information associated with the receipt ID:"
        );
      }
    }
    //eslint-disable-next-line
  }, [userToken, location]);

  const {
    bookedOn,
    bookingRefId,
    carFullName,
    coverageDetails,
    dropOffAddressInfo1,
    dropOffAddressInfo2,
    initialBooking,
    milesIncluded,
    milesUsed,
    pickupAddressInfo1,
    pickupAddressInfo2,
    pricingDetails,
    tripStart,
    tripEnd,
    tripPrice,
    vehicleDetails,
    emrDetails,
    guestDetails,
  } = tripReceiptDetails || {};

  const {
    color,
    licensePlate,
    make,
    model,
    stateCode,
    tollPassId,
    tollingAgency,
    vehicleName,
    vinNumber,
    year,
  } = vehicleDetails || {};

  const { initialEndDate, initialStartDate, noOfDays, totalAmount } =
    initialBooking || {};

  const {
    guestName,
    email,
    countryCode,
    phoneNumber,
    licenseState,
    licenseNumber,
    licenseExpiryDate,
    billing,
    mailing,
  } = guestDetails || {};

  function formatPhoneNumber(countryCode, phoneNumber) {
    // Clean inputs (remove non-digits)
    const cleanCountryCode = countryCode.toString().replace(/\D/g, "");
    const cleanPhoneNumber = phoneNumber.toString().replace(/\D/g, "");

    // Extract parts
    const areaCode = cleanPhoneNumber.slice(0, 3);
    const part1 = cleanPhoneNumber.slice(3, 6);
    const part2 = cleanPhoneNumber.slice(6);

    // Format and return
    return `+${cleanCountryCode} (${areaCode}) ${part1} ${part2}`;
  }

  return (
    <div>
      {userToken ? (
        <div className="fontAntarctica">
          <div className="tripReceiptNavbarBorder  bgF2F0FD p-3 d-flex justify-content-between align-items-center px-lg-5">
            <div className="cursorPointer" onClick={() => navigate("/")}>
              <img src={joulezLightIcon} alt="icon" />
            </div>
            {tripError ? (
              ""
            ) : (
              <div
                className="p-2 fontColorCE1 fontSize13 cursorPointer no-print"
                onClick={() => {
                  setShowDetails(true);
                  setTimeout(() => {
                    window.print();
                  }, 100);
                }}
              >
                <img className="mx-2" src={printIcon} alt="printIcon" />
                <span>Print</span>{" "}
              </div>
            )}
          </div>
          {loader ? (
            <div className="overlay">
              <div className="spinner-container">
                <SpinnerLoader />
              </div>
            </div>
          ) : !tripError ? (
            tripReceiptDetails && (
              <div className="tripReceiptMarginTop">
                <div className="pt-3 pb-3 px-3 px-lg-5 d-flex align-items-center">
                  <div className="col-6">
                    <div className="fontColor1321 tripTitles">Trip Receipt</div>
                  </div>
                  <div className="col-6">
                    <div className="tripTitles">
                      <span>Booking ID</span>{" "}
                      <span className="fontColorCE1">{bookingRefId}</span>
                    </div>
                  </div>
                </div>
                <div className="bookingDetailsTransactionHrLine"></div>

                <div className="d-flex align-items-center p-3 px-lg-5 bgF9FF fontColor1321 tripCarModel">
                  <div className="col-6">{carFullName}</div>
                  <div className="col-6">Booked on {bookedOn}</div>
                </div>

                {/*Guest Details */}
                <div className="p-3 p-lg-3 px-lg-5 tripReceiptGuestDetails">
                  <div className="tripeVehicleDetailsTitle mb-3">
                    Guest Details
                  </div>
                  <div>
                    <div className="d-flex justify-content-start flex-wrap">
                      <div className="col-12 col-sm-4 col-md-4 col-lg-3">
                        <div className="tripVehicleLabel">Guest Name</div>
                        <div className="tripeVehicleValues mb-2">
                          {guestName}
                        </div>
                        {licenseNumber && (
                          <div className="d-none d-sm-block">
                            <div className="tripVehicleLabel">
                              Driver License Number
                            </div>
                            <div className="tripeVehicleValues mb-2">
                              {licenseNumber}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-sm-4 col-md-4 col-lg-2">
                        {phoneNumber && (
                          <div>
                            <div className="tripVehicleLabel">Phone Number</div>
                            <div className="tripeVehicleValues mb-2">
                              {formatPhoneNumber(countryCode, phoneNumber)}
                            </div>
                          </div>
                        )}
                        {licenseState && (
                          <div className="d-none d-sm-block">
                            <div className="tripVehicleLabel">State</div>
                            <div className="tripeVehicleValues mb-2">
                              {licenseState}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-sm-4 col-md-4 col-lg-3">
                        {email && (
                          <div>
                            <div className="tripVehicleLabel">Email</div>
                            <div className="tripeVehicleValues mb-2">
                              {email}
                            </div>
                          </div>
                        )}

                        <div className="d-block d-sm-none">
                          {licenseNumber && (
                            <div>
                              <div className="tripVehicleLabel">
                                Driver License Number
                              </div>
                              <div className="tripeVehicleValues mb-2">
                                {licenseNumber}
                              </div>
                            </div>
                          )}
                          <div className="d-flex">
                            {licenseState && (
                              <div className="col-6">
                                <div className="tripVehicleLabel">State</div>
                                <div className="tripeVehicleValues mb-2">
                                  {licenseState}
                                </div>
                              </div>
                            )}
                            {licenseExpiryDate && (
                              <div className="col-6">
                                <div className="tripVehicleLabel">
                                  Expiration 
                                </div>
                                <div className="tripeVehicleValues mb-2">
                                  {licenseExpiryDate}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {licenseExpiryDate && (
                          <div className="d-none d-sm-block">
                            <div className="tripVehicleLabel">Expiration</div>
                            <div className="tripeVehicleValues mb-2">
                              {licenseExpiryDate}
                            </div>
                          </div>
                        )}
                      </div>
                      {billing !== null && (
                        <div className="col-12 col-sm-4 col-md-4 col-lg-2">
                          <div className="tripVehicleLabel">
                            Billing Address
                          </div>
                          <div className="tripeVehicleValues mb-2">
                            <div>{billing?.line1}</div>
                            <div>{billing?.line2}</div>
                            <div>{billing?.line3}</div>
                          </div>
                        </div>
                      )}
                      {mailing !== null && (
                        <div className="col-12 col-sm-4 col-md-4 col-lg-2">
                          <div className="tripVehicleLabel">
                            Mailing Address
                          </div>
                          <div className="tripeVehicleValues mb-2">
                           <div>{mailing?.line1}</div>
                           <div>{mailing?.line2}</div>
                           <div>{mailing?.line3}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/*Vehicle Details */}
                <div className="p-3 p-lg-3 px-lg-5 tripReceiptVehicelDetails">
                  <div className="tripeVehicleDetailsTitle mb-3">
                    Vehicle Details
                  </div>
                  <div className="d-flex flex-wrap">
                    {vehicleName && (
                      <div className="col-6 col-sm-3 col-md-3 col-lg-3">
                        <div className="tripVehicleLabel">Vehicle Name</div>
                        <div className="tripeVehicleValues mb-2">
                          {vehicleName}
                        </div>
                      </div>
                    )}
                    {make && (
                      <div className="col-6 col-sm-3 col-md-3 col-lg-2">
                        <div className="tripVehicleLabel">Make</div>
                        <div className="tripeVehicleValues mb-2">{make}</div>
                      </div>
                    )}
                    {model && (
                      <div className="col-6 col-sm-3 col-md-3 col-lg-3">
                        <div className="tripVehicleLabel">Model</div>
                        <div className="tripeVehicleValues mb-2">{model}</div>
                      </div>
                    )}
                    {year && (
                      <div className="col-6 col-sm-3 col-md-3 col-lg-2">
                        <div className="tripVehicleLabel">Year</div>
                        <div className="tripeVehicleValues mb-2">{year}</div>
                      </div>
                    )}
                    {color && (
                      <div className="col-6 col-sm-3 col-md-3 col-lg-2">
                        <div className="tripVehicleLabel">Color</div>
                        <div className="tripeVehicleValues mb-2">{color}</div>
                      </div>
                    )}
                    {vinNumber && (
                      <div className="col-6 col-sm-3 col-md-3 col-lg-3">
                        <div className="tripVehicleLabel">VIN</div>
                        <div className="tripeVehicleValues mb-2">
                          {vinNumber}
                        </div>
                      </div>
                    )}
                    {licensePlate && (
                      <div className="col-6 col-sm-3 col-md-3 col-lg-2">
                        <div className="tripVehicleLabel">License Plate</div>
                        <div className="tripeVehicleValues mb-2">
                          {licensePlate}
                        </div>
                      </div>
                    )}
                    {stateCode && (
                      <div className="col-6 col-sm-3 col-md-3 col-lg-3">
                        <div className="tripVehicleLabel">
                          State (License Plate)
                        </div>
                        <div className="tripeVehicleValues mb-2">
                          {stateCode}
                        </div>
                      </div>
                    )}
                    {tollPassId && (
                      <div className="col-6 col-sm-3 col-md-3 col-lg-2">
                        <div className="tripVehicleLabel">Toll Pass ID</div>
                        <div className="tripeVehicleValues mb-2">
                          {tollPassId}
                        </div>
                      </div>
                    )}
                    {tollingAgency && (
                      <div className="col-6 col-sm-3 col-md-3 col-lg-2">
                        <div className="tripVehicleLabel">Tolling Agency</div>
                        <div className="tripeVehicleValues mb-2">
                          {tollingAgency}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="d-flex align-items-center p-3 px-lg-5">
                  <div className="col-6">
                    <div className="fontColor8A8A tripStartAndEndTitles">
                      Trip Start
                    </div>
                    <div className="tripStartAndEndDates fontColor1321">
                      <div className="my-2">{tripStart}</div>
                      <div className="my-2">{pickupAddressInfo1}</div>
                      <div className="my-2">{pickupAddressInfo2}</div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="fontColor8A8A tripStartAndEndTitles">
                      Trip End
                    </div>
                    <div className="tripStartAndEndDates fontColor1321">
                      <div className="my-2">{tripEnd}</div>
                      <div className="my-2">{dropOffAddressInfo1}</div>
                      <div className="my-2">{dropOffAddressInfo2}</div>
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-center p-3 px-lg-5 bgF9FF fontColor1321">
                  {milesIncluded && (
                    <div className="col-6">
                      <div className="milesIncludedTitle">Miles Included</div>
                      <div className="milesIncludedValue">{milesIncluded}</div>
                    </div>
                  )}
                  {milesUsed && (
                    <div className="col-6">
                      <div className="milesIncludedTitle">Miles Used</div>
                      <div className="milesIncludedValue">{milesUsed}</div>
                    </div>
                  )}
                </div>

                <div className="tripPriceTitleAndValue p-2 d-flex justify-content-between align-items-center p-3 px-lg-5 bgF9FF fontColor1321">
                  <div className="tripPriceTitle">Trip Price</div>
                  <div className="tripPriceValue">{tripPrice}</div>
                </div>

                <div>
                  <div className="p-3 px-lg-5">
                    <div>
                      <div className="d-flex justify-content-between align-items-center  py-1">
                        <div className="tripPricingDetailsTitle">
                          Pricing Details
                        </div>
                        <div
                          onClick={() => {
                            setShowDetails(!showDetails);
                          }}
                          className="fontColorCE1 cursorPointer tripViewDetailed"
                        >
                          {showDetails ? "View Less" : "View Detailed"}
                        </div>
                      </div>
                      <hr className="my-1" />
                      {pricingDetails?.length > 0 &&
                        pricingDetails?.map((details, index) => {
                          return (
                            <div key={index}>
                              <div className="d-flex justify-content-between align-items-center p-1">
                                <div className="tripBreakupTitlesAndValues">
                                  <div>{details?.title}</div>
                                  {details?.subTitle && (
                                    <span className="fontSize12">
                                      {details?.subTitle}
                                    </span>
                                  )}
                                </div>
                                <div> {details?.value}</div>
                              </div>
                              <div>
                                {showDetails &&
                                  details?.lineItems &&
                                  details?.lineItems?.map((items, index) => {
                                    return (
                                      <div
                                        key={items?.title}
                                        className="fontSize13"
                                      >
                                        <div className="opacity70 d-flex justify-content-between align-items-center p-1">
                                          <div>
                                            {items?.title}{" "}
                                            {items?.subTitle && (
                                              <span className="fontSize10">
                                                {items?.subTitle}
                                              </span>
                                            )}
                                          </div>
                                          <div> {items?.value}</div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>

                <div className="p-3 px-lg-5">
                  <div className="coverageIncludedTitle">Coverage Included</div>
                  <div className="d-flex flex-wrap  justify-content-between align-items-center">
                    {coverageDetails?.map((details) => {
                      return (
                        <div
                          key={details?.id}
                          className="tripCoverageDetails p-2 m-1"
                        >
                          <div className="tripCoverageTitle">
                            {details?.title}
                          </div>
                          <ul className="tripCoverageInfo">
                            {details?.info1 && (
                              <li className="m-1">{details?.info1}</li>
                            )}
                            {details?.info2 && (
                              <li className="m-1">{details?.info2}</li>
                            )}
                            {details?.info3 && (
                              <li className="m-1">{details?.info3}</li>
                            )}
                          </ul>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="px-3 py-2 py-lg-2 px-lg-5">
                  <div className="initialBookingTitle mb-2">
                    Initial Booking
                  </div>
                  <div>
                    <div className="d-flex justify-content-between align-items-center initialDetailValues p-3">
                      <div>
                        <div className="mb-2">{initialStartDate}</div>
                        <div>{initialEndDate}</div>
                      </div>
                      <div className="text-end">
                        <div className="mb-2 text-end">{noOfDays}</div>
                        <div className="text-end">{totalAmount}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="px-3 py-2 py-lg-2 px-lg-5">
                  {(emrDetails !== null || emrDetails?.length > 0) && (
                    <div className="my-2 modificationsTitle">Modifications</div>
                  )}
                  {emrDetails?.map(
                    ({
                      oldStartDate,
                      oldEndDate,
                      newStartDate,
                      newEndDate,
                      emrModifiedOn,
                      emrId,
                      totalAmount,
                      noOfDays,
                      comments,
                    }) => {
                      return (
                        <div key={emrId}>
                          <div className="mainModificationContainer p-3 mb-3">
                            <div className="d-flex justify-content-between align-items-center my-2">
                              <div>
                                <div className="mb-2">
                                  {oldStartDate === null ? (
                                    <span className="modificationStartAndEndDates">
                                      {newStartDate}
                                    </span>
                                  ) : (
                                    <div className="d-flex flex-column flex-lg-row">
                                      <div className="modificationStrikeThrough">
                                        {oldStartDate}
                                      </div>{" "}
                                      <div className="modificationStartAndEndDates mx-0 mx-lg-2">
                                        {newStartDate}
                                      </div>{" "}
                                    </div>
                                  )}
                                </div>
                                <div>
                                  {oldEndDate === null ? (
                                    <span className="modificationStartAndEndDates">
                                      {newEndDate}
                                    </span>
                                  ) : (
                                    <div className="d-flex flex-column align-items-center flex-lg-row">
                                      <div className="modificationStrikeThrough">
                                        {oldEndDate}
                                      </div>{" "}
                                      <div className="modificationStartAndEndDates mx-0 mx-lg-2">
                                        {newEndDate}
                                      </div>{" "}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div>
                                <div className="mb-2 modificationDays text-end">
                                  {noOfDays}
                                </div>
                                <div className="modificationTotalAmount text-end">
                                  {totalAmount}
                                </div>
                              </div>
                            </div>
                            <div>
                              <div>
                                <div>
                                  {comments && (
                                    <div className="commentsSection">
                                      Comments
                                    </div>
                                  )}
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div className="commentDescription">
                                      {comments && comments}
                                    </div>
                                    {emrModifiedOn && (
                                      <div className="commentsSection">
                                        {emrModifiedOn}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            )
          ) : (
            <div>
              <div className="d-flex flex-column justify-content-center align-items-center min-vh-100">
                <div>
                  <img
                    className="accessDeniedLogo"
                    src={accessDeniedLogo}
                    alt="accessDeniedLogo"
                  />{" "}
                </div>
                <div className="tripErrorFont">{tripError}</div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="pt-5 d-flex flex-column justify-content-center align-items-center bg2B2B2B text-white receiptContainer fontAntarctica">
          <div className="my-1">Please login to see the receipt</div>
          <div
            className="br8 cursorPointer m-lg-0 tripReceiptLoginButton fontSize13"
            onClick={() => {
              dispatch(setOpenLoginDesktopModal(true));
            }}
          >
            Log in
          </div>
        </div>
      )}
    </div>
  );
};

export default TripReceiptDetails;
